export enum InputAutocomplete {
  OFF = 'off',
  NEW_PASSWORD = 'new-password',
}

export enum InputMode {
  DECIMAL = 'decimal',
  EMAIL = 'email',
  NONE = 'none',
  NUMERIC = 'numeric',
  SEARCH = 'search',
  TEL = 'tel',
  TEXT = 'text',
  URL = 'url',
}

export enum InputType {
  EMAIL = 'email',
  TEXT = 'text',
  PASSWORD = 'password',
}
